/**
 * @generated SignedSource<<7dccc9ffb63599ef2bcb48e6ab99aa8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type columnPicker_issueViewChildIssuesPanel$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueTableColumnPicker_ColumnConfig_columns">;
  readonly " $fragmentType": "columnPicker_issueViewChildIssuesPanel";
};
export type columnPicker_issueViewChildIssuesPanel$key = {
  readonly " $data"?: columnPicker_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "columnPicker_issueViewChildIssuesPanel",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueTableColumnPicker_ColumnConfig_columns"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "b3cc13a031bfb2904c5b7a5447dd8756";

export default node;
